export * from './classic-deposit-config.interface';
export * from './classic-navigation-option.interface';
export * from './classic-player-config.interface';
export * from './classic-victory-modal-payload.interface';
export * from './classic-widget-config.interface';
export * from './classic-winner-config.interface';
export * from './dto';
